export default {
    CHANGE_QUESTION_MODEL_CONFIRM_DIALOG: {
        MESSAGE: 'Αλλάζοντας το μοντέλο αυτής της ερώτησης, οποιεσδήποτε πληροφορίες έχουν ήδη απαντηθεί σε αυτήν την ερώτηση θα χαθούν. Επικοινωνήστε με την Enginehire για τυχόν ερωτήσεις.',
        ACCEPT_LABEL: "Συνέχεια",
        REJECT_LABEL: "Ακύρωση"
    },
    DELETE_REFERENCE_CONFIRM_DIALOG: {
        MESSAGE: 'Είστε βέβαιοι ότι θέλετε να διαγράψετε αυτήν την αναφορά;',
        ACCEPT_LABEL: "Διαγραφή",
        REJECT_LABEL: "Ακύρωση"
    },
    DELETE_EXPERIENCE_CONFIRM_DIALOG: {
        MESSAGE: "Είστε βέβαιοι ότι θέλετε να διαγράψετε αυτήν την εμπειρία;",
        ACCEPT_LABEL: "Διαγραφή",
        REJECT_LABEL: "Ακύρωση"
    },
    DELETE_CONTACT_CONFIRM_DIALOG: {
        MESSAGE: 'Είστε βέβαιοι ότι θέλετε να διαγράψετε αυτήν την επαφή;',
        ACCEPT_LABEL: "Διαγραφή",
        REJECT_LABEL: "Ακύρωση"
    },
    DELETE_EDUCATION_CONFIRM_DIALOG: {
        MESSAGE: "Είστε βέβαιοι ότι θέλετε να διαγράψετε αυτήν την εκπαίδευση;",
        ACCEPT_LABEL: "Διαγραφή",
        REJECT_LABEL: "Ακύρωση"
    },
    DELETE_CHILDREN_CONFIRM_DIALOG: {
        MESSAGE: "Είστε βέβαιοι ότι θέλετε να διαγράψετε αυτό το παιδί;",
        ACCEPT_LABEL: "Διαγραφή",
        REJECT_LABEL: "Ακύρωση"
    },
    DELETE_PET_CONFIRM_DIALOG: {
        MESSAGE: 'Είστε βέβαιοι ότι θέλετε να διαγράψετε αυτό το κατοικίδιο;',
        ACCEPT_LABEL: "Διαγραφή",
        REJECT_LABEL: "Ακύρωση"
    },
    DELETE_BOOKING_CONFIRM_DIALOG: {
        MESSAGE: 'Είστε βέβαιοι ότι θέλετε να διαγράψετε αυτήν την κράτηση;',
        ACCEPT_LABEL: "Διαγραφή",
        REJECT_LABEL: "Ακύρωση"
    },
    DELETE_PROFILE_BUILDER_CONFIRM_DIALOG: {
        MESSAGE: 'Είστε βέβαιοι ότι θέλετε να διαγράψετε το εργαλείο δημιουργίας προφίλ {0};',
        ACCEPT_LABEL: "Διαγραφή",
        REJECT_LABEL: "Ακύρωση"
    },
    DELETE_REQUEST_CONFIRM_DIALOG: {
        MESSAGE: 'Είστε βέβαιοι ότι θέλετε να διαγράψετε αυτό το αίτημα;',
        ACCEPT_LABEL: "Διαγραφή",
        REJECT_LABEL: "Ακύρωση"
    },
    DELETE_JOB_CONFIRM_DIALOG: {
        MESSAGE: 'Είστε βέβαιοι ότι θέλετε να διαγράψετε αυτήν την εργασία;',
        ACCEPT_LABEL: "Διαγραφή",
        REJECT_LABEL: "Ακύρωση"
    },
    DELETE_APPLICATION_CONFIRM_DIALOG: {
        MESSAGE: 'Είστε βέβαιοι ότι θέλετε να διαγράψετε αυτήν την εφαρμογή;',
        ACCEPT_LABEL: "Διαγραφή",
        REJECT_LABEL: "Ακύρωση"
    },
    DELETE_DOCUMENT_CONFIRM_DIALOG: {
        MESSAGE: 'Είστε βέβαιοι ότι θέλετε να διαγράψετε το έγγραφο {0};',
        ACCEPT_LABEL: "Διαγραφή εγγράφου",
        REJECT_LABEL: "Κλείσιμο"
    },
    BULK_DELETE_DOCUMENT_CONFIRM_DIALOG: {
        MESSAGE: 'Είστε απολύτως βέβαιοι ότι θέλετε να διαγράψετε αυτά τα έγγραφα;',
        ACCEPT_LABEL: "Διαγραφή εγγράφων",
        REJECT_LABEL: "Κλείσιμο"
    },
    DELETE_FILE_CONFIRM_DIALOG: {
        MESSAGE: 'Είστε βέβαιοι ότι θέλετε να διαγράψετε το αρχείο;',
        ACCEPT_LABEL: "Διαγραφή",
        REJECT_LABEL: "Κλείσιμο"
    },
    DELETE_TEMPLATE_CONFIRM_DIALOG: {
        MESSAGE: 'Είστε βέβαιοι ότι θέλετε να διαγράψετε το πρότυπο {0} {1};',
        ACCEPT_LABEL: "Διαγραφή",
        REJECT_LABEL: "Ακύρωση"
    },
    DELETE_PRICE_CONFIRM_DIALOG: {
        MESSAGE: 'Είστε βέβαιοι ότι θέλετε να διαγράψετε το {0} {1};',
        ACCEPT_LABEL: "Διαγραφή",
        REJECT_LABEL: "Ακύρωση"
    },
    DELETE_PHOTO_CONFIRM_DIALOG: {
        MESSAGE: 'Είστε βέβαιοι ότι θέλετε να διαγράψετε τη φωτογραφία {0};',
        ACCEPT_LABEL: "Διαγραφή",
        REJECT_LABEL: "Ακύρωση"
    },
    DELETE_PICTURE_CONFIRM_DIALOG: {
        MESSAGE: 'Είστε βέβαιοι ότι θέλετε να διαγράψετε την εικόνα;',
        ACCEPT_LABEL: "Διαγραφή",
        REJECT_LABEL: "Ακύρωση"
    },
    DELETE_USER_CONFIRM_DIALOG: {
        INNER_HTML: `<h3>Είστε βέβαιοι ότι θέλετε να διαγράψετε αυτόν τον χρήστη;</h3>
         <p>{0} {1}</p>
         <p>{2}</p>`,
        ACCEPT_LABEL: "Διαγραφή",
        REJECT_LABEL: "Ακύρωση"
    },
    DELETE_ADMIN_CONFIRM_DIALOG: {
        INNER_HTML: `<h3>Είστε βέβαιοι ότι θέλετε να διαγράψετε αυτόν τον χρήστη;</h3>
         <p>{0}</p>`,
        ACCEPT_LABEL: "Διαγραφή",
        REJECT_LABEL: "Ακύρωση"
    },
    DELETE_RESOURCE_CONFIRM_DIALOG: {
        MESSAGE: 'Είστε βέβαιοι ότι θέλετε να καταργήσετε το {0};',
        ACCEPT_LABEL: "Διαγραφή",
        REJECT_LABEL: "Ακύρωση"
    },
    DELETE_TIME_OFF_CONFIRM_DIALOG: {
        MESSAGE: 'Είστε βέβαιοι ότι θέλετε να καταργήσετε αυτό το αίτημα χρονικού ορίου',
        ACCEPT_LABEL: "Διαγραφή",
        REJECT_LABEL: "Ακύρωση"
    },
    CANCEL_BOOKING_CONFIRM_DIALOG: {
        MESSAGE: 'Είστε βέβαιοι ότι θέλετε να ακυρώσετε αυτήν την κράτηση;',
        ACCEPT_LABEL: 'Ναι',
        REJECT_LABEL: "Όχι"
    },
    CANCELLATION_FEE_CONFIRM_DIALOG: {
        MESSAGE: 'Το τέλος ακύρωσης είναι ${0}. Εισαι σιγουρος οτι θελεις να συνεχισεις?',
        ACCEPT_LABEL: 'Ναι',
        REJECT_LABEL: "Όχι"
    },
    CANCEL_CONFIRM_DIALOG: {
        MESSAGE: 'Είστε βέβαιοι ότι θέλετε να κλείσετε; Οποιεσδήποτε αλλαγές θα χαθούν.',
        ACCEPT_LABEL: 'Ναι',
        REJECT_LABEL: "Όχι"
    },
    ACCEPT_JOB_CONFIRM_DIALOG: {
        MESSAGE: 'Είστε βέβαιοι ότι θέλετε να αποδεχτείτε την εργασία {0};',
        ACCEPT_LABEL: 'Ναι',
        REJECT_LABEL: "Όχι"
    },
    DECLINE_JOB_CONFIRM_DIALOG: {
        MESSAGE: 'Είστε βέβαιοι ότι θέλετε να απορρίψετε την εργασία {0};',
        ACCEPT_LABEL: 'Ναι',
        REJECT_LABEL: "Όχι"
    },
    EDIT_CONFIRM_DIALOG: {
        MESSAGE: 'Είστε σίγουροι για τις αλλαγές σας;',
        ACCEPT_LABEL: 'Ναι',
        REJECT_LABEL: "Όχι"
    },
    BULK_OVERWRITE_DATA_CONFIRM_DIALOG: {
        INNER_HTML: `<h2>Είστε βέβαιοι ότι θέλετε να αντικαταστήσετε {0} από τους επιλεγμένους χρήστες;</h2><h5 class="text-danger">Αυτό θα αντικαταστήσει τα υπάρχοντα {0} αυτών των χρηστών με "{1}" .</h5>`,
        ACCEPT_LABEL: 'Ναι',
        REJECT_LABEL: "Όχι"
    },
    BULK_ADD_DATA_CONFIRM_DIALOG: {
        INNER_HTML: `<h2>Είστε βέβαιοι ότι θέλετε να προσθέσετε το {0} στους επιλεγμένους χρήστες;</h2><h5 class="text-danger">Αυτό θα προσθέσει το "{1}" στο υπάρχον {0} του χρήστη. </h5>`,
        ACCEPT_LABEL: 'Ναι',
        REJECT_LABEL: "Όχι"
    },
    BULK_STATUS_CHANGE_CONFIRM_DIALOG: {
        MESSAGE: 'Είστε βέβαιοι ότι θέλετε να αλλάξετε την κατάσταση των {0} επιλεγμένων χρηστών; Η κατάστασή τους θα αλλάξει σε {1}.',
        ACCEPT_LABEL: 'Ναι',
        REJECT_LABEL: "Όχι"
    },
    BULK_ADD_USER_MAILCHIMP_CONFIRM_DIALOG: {
        INNER_HTML: `<h2>Είστε βέβαιοι ότι θέλετε να προσθέσετε τους επιλεγμένους χρήστες στο mailchimp;</h2>`,
        ACCEPT_LABEL: 'Ναι',
        REJECT_LABEL: "Όχι"
    },
    OVERWRITE_VIDEO_CONFIRM_DIALOG: {
        MESSAGE: 'Υπάρχει ένα ηχογραφημένο βίντεο. Εάν εγγράψετε νέο βίντεο, το υπάρχον βίντεο θα αντικατασταθεί. Είστε σίγουροι ότι θα συνεχίσετε;',
        ACCEPT_LABEL: "Συνέχεια",
        REJECT_LABEL: "Ακύρωση"
    },
    DELETE_VIDEO_CONFIRM_DIALOG: {
        MESSAGE: 'Είστε βέβαιοι ότι θέλετε να διαγράψετε το βίντεο;',
        ACCEPT_LABEL: "Διαγραφή",
        REJECT_LABEL: "Ακύρωση"
    },
    DELETE_PROFILE_PICTURE_CONFIRM_DIALOG: {
        MESSAGE: 'Είστε βέβαιοι ότι θέλετε να διαγράψετε την εικόνα προφίλ;',
        ACCEPT_LABEL: "Διαγραφή εικόνας",
        REJECT_LABEL: "Κλείσιμο"
    },
    DELETE_RELATIONSHIP_CONFIRM_DIALOG: {
        MESSAGE: "Είστε βέβαιοι ότι θέλετε να καταργήσετε τη σύνδεση μεταξύ του {0} και αυτού του πελάτη;",
        ACCEPT_LABEL: "Διαγραφή",
        REJECT_LABEL: "Ακύρωση"
    },
    CANDIDATE_ACCEPT_JOB_CONFIRM_DIALOG: {
        MESSAGE: 'Δεσμεύεστε να ολοκληρώσετε αυτήν τη θέση εργασίας, είστε σίγουροι;',
        ACCEPT_LABEL: "Αποδοχή εργασίας",
        REJECT_LABEL: "Κλείσιμο"
    },
    MARK_AS_FAVORITE_CONFIRM_DIALOG: {
        MESSAGE: 'Είστε βέβαιοι ότι θέλετε να επισημάνετε το {0} ως αγαπημένο;',
        ACCEPT_LABEL: 'Ναι',
        REJECT_LABEL: "Όχι"
    },
    MARK_AS_DO_NOT_WANT_CONFIRM_DIALOG: {
        MESSAGE: 'Είστε βέβαιοι ότι δεν θέλετε ξανά το {0};',
        ACCEPT_LABEL: 'Ναι',
        REJECT_LABEL: "Όχι"
    },
    DELETE_NOTE_CONFIRM_DIALOG: {
        INNER_HTML: `<h3>Είστε βέβαιοι ότι θέλετε να διαγράψετε τη σημείωση;</h3>
         <p style="white-space: pre-wrap;">{0}</p>`,
        ACCEPT_LABEL: "Διαγραφή",
        REJECT_LABEL: "Ακύρωση"
    },
    DELETE_EVENT_CONFIRM_DIALOG: {
        INNER_HTML: `<h3>Είστε βέβαιοι ότι θέλετε να διαγράψετε τον προγραμματιστή συμβάντων;</h3>
        <p style="white-space: pre-wrap;">{0}</p>`,
        ACCEPT_LABEL: "Διαγραφή",
        REJECT_LABEL: "Ακύρωση"
    },
    DELETE_CREDIT_CONFIRM_DIALOG: {
        MESSAGE: 'Είστε βέβαιοι ότι θέλετε να διαγράψετε αυτήν την πίστωση;',
        ACCEPT_LABEL: "Διαγραφή",
        REJECT_LABEL: "Ακύρωση"
    },
    DELETE_MULTI_ITEMS_CONFIRM_DIALOG: {
        MESSAGE: "Είστε βέβαιοι ότι θέλετε να διαγράψετε τα {0} επιλεγμένα {1};",
        ACCEPT_LABEL: "Ναι",
        REJECT_LABEL: "Όχι"
    },
    UNASSIGN_JOBS_CONFIRM_DIALOG: {
        MESSAGE: 'Είστε βέβαιοι ότι θέλετε να καταργήσετε την ανάθεση {0} επιλεγμένων εργασιών; Η κατάστασή τους θα τεθεί σε "{1}".',
        ACCEPT_LABEL: "Ναι",
        REJECT_LABEL: "Όχι"
    },
    BULK_CHANGE_JOB_STATUS_CONFIMR_DIALOG: {
        MESSAGE: "Είστε βέβαιοι ότι θέλετε να αλλάξετε την κατάσταση των {0} επιλεγμένων εργασιών; Η κατάστασή τους θα αλλάξει σε {1}.",
        ACCEPT_LABEL: "Ναι",
        REJECT_LABEL: "Όχι"
    },
    ASSIGN_JOB_CONFIRM_DIALOG: {
        MESSAGE: "Είστε βέβαιοι ότι θέλετε να αναθέσετε την εργασία στον υποψήφιο;",
        ACCEPT_LABEL: "Ναι",
        REJECT_LABEL: "Όχι"
    },
    BULK_ASSIGN_CANDIDIATES_TO_MULTIPLE_JOBS_DIALOG: {
        MESSAGE: "Είστε βέβαιοι ότι θέλετε να αναθέσετε {0} επιλεγμένες εργασίες στον επιλεγμένο υποψήφιο;",
        ACCEPT_LABEL: "Ναι",
        REJECT_LABEL: "Όχι"
    },
    BULK_TENTATIVELY_ASSIGN_CANDIDIATES_TO_MULTIPLE_JOBS_DIALOG: {
        MESSAGE: "Είστε βέβαιοι ότι θέλετε να αναθέσετε προσωρινά {0} επιλεγμένες εργασίες στον επιλεγμένο υποψήφιο;",
        ACCEPT_LABEL: "Ναι",
        REJECT_LABEL: "Όχι"
    },
    PACKAGE_SELECTION_CONFIRMATION: {
        INNER_HTML: `<h2>Επιβεβαίωση επιλογής - {0}</h2>
        <hr />
        ΑΑΑΑΑΑΑΑΑ_<h5>
          Έχω διαβάσει και είμαι σίγουρος για τους όρους και τις προϋποθέσεις του
          Επιλέχτηκε package.
        </h5>`,
        ACCEPT_LABEL: "Επιβεβαίωση επιλογής",
        REJECT_LABEL: "Ακύρωση"
    },
    DELETE_EVALUATION_CONFIRM_DIALOG: {
        MESSAGE: 'Είστε βέβαιοι ότι θέλετε να διαγράψετε αυτήν την αξιολόγηση;',
        ACCEPT_LABEL: "Διαγραφή",
        REJECT_LABEL: "Ακύρωση"
    },
    DELETE_QUESTION_CONFIRM_DIALOG: {
        MESSAGE: 'Είστε βέβαιοι ότι θέλετε να διαγράψετε αυτήν την ερώτηση;',
        ACCEPT_LABEL: "Διαγραφή",
        REJECT_LABEL: "Ακύρωση"
    },
    DELETE_OPTION_CONFIRM_DIALOG: {
        MESSAGE: 'Είστε βέβαιοι ότι θέλετε να διαγράψετε αυτήν την επιλογή;',
        ACCEPT_LABEL: "Διαγραφή",
        REJECT_LABEL: "Ακύρωση"
    },
    POST_WEEK_AVAILABLITY_CONFIRM_DIALOG: {
        MESSAGE: 'Είστε σίγουροι για τη διαθεσιμότητα που έχετε καταχωρίσει;',
        ACCEPT_LABEL: 'Επιβεβαίωση διαθεσιμότητας',
        REJECT_LABEL: "Περιμένετε, επιτρέψτε μου να ελέγξω ξανά"
    },
    TIME_OFF_REQUEST_CONFIRM_DIALOG: {
        MESSAGE: 'Είστε σίγουροι για το αίτημά σας;',
        ACCEPT_LABEL: 'Υποβολή αιτήματος',
        REJECT_LABEL: "Αίτημα επεξεργασίας"
    },
    REMOVE_AVAILABILITY_CONFIRM_DIALOG: {
        MESSAGE: '{0} ({1}) - Κατάργηση διαθεσιμότητας',
        ACCEPT_LABEL: "Διαγραφή",
        REJECT_LABEL: "Ακύρωση"
    },
    DELETE_WEEK_AVAILABILITY_CONFIRM_DIALOG: {
        MESSAGE: 'Είστε βέβαιοι ότι θέλετε να διαγράψετε την εβδομαδιαία διαθεσιμότητα;',
        ACCEPT_LABEL: "Διαγραφή",
        REJECT_LABEL: "Ακύρωση"
    },
    RESET_WEEK_AVAILABILITY: {
        MESSAGE: 'Είστε βέβαιοι ότι θέλετε να επαναφέρετε την εβδομαδιαία διαθεσιμότητα;',
        ACCEPT_LABEL: 'Ναι',
        REJECT_LABEL: "Όχι"
    },
    SUBMIT_REQUEST_CONFIRM_DIALOG: {
        MESSAGE: "Είστε σίγουροι για το αίτημά σας;",
        ACCEPT_LABEL: "Υποβολή αιτήματος",
        REJECT_LABEL: "Αίτημα επεξεργασίας"
    },
    SUBMIT_REQUEST_CONFIRM_DIALOG: {
        MESSAGE: "Είστε σίγουροι για το αίτημά σας;",
        ACCEPT_LABEL: "Υποβολή αιτήματος",
        REJECT_LABEL: "Αίτημα επεξεργασίας"
    },
    FORCE_LOGIN_CONFIRM_DIALOG: {
        INNER_HTML: '<h4>Είστε ήδη συνδεδεμένοι!</h4>'
            + '<h5>Λυπούμαστε, φαίνεται ότι είστε ήδη συνδεδεμένοι σε άλλη συσκευή! '
            + 'Παρακαλώ αποσυνδεθείτε από οπουδήποτε αλλού και δοκιμάστε ξανά. '
            + 'Εάν έχετε ερωτήσεις, <a href="https://share.hsforms.com/1yIx2IRKyQQaVcMJW8kLbJg39wil">επικοινωνήστε μαζί μας</a>.</h5>',
        ACCEPT_LABEL: 'Είσοδος πάντως',
        REJECT_LABEL: "ΟΚ"
    },
    MARK_ALL_AS_PUBLIC_CONFIRM_DIALOG: {
        MESSAGE: "Είστε βέβαιοι ότι θέλετε να επισημάνετε όλα τα {0} ως δημόσια (ορατά σε όλους);",
        ACCEPT_LABEL: 'Ναι',
        REJECT_LABEL: "Όχι"
    },
    BROADCAST_SMS_CONFIRM_DIALOG: {
        MESSAGE: "Είστε βέβαιοι ότι θέλετε να στείλετε SMS σε χρήστες {0}",
        ACCEPT_LABEL: 'Ναι',
        REJECT_LABEL: "Όχι"
    },
    CREATE_JOB_CONFIRM_DIALOG: {
        INNER_HTML: '<h4>Δημιουργία εργασίας</h4>'
            + '<hr>' +
            '<h5>Εάν ξεκινάτε μια δουλειά, αλλά δεν αναφέρεται στο πρόγραμμά σας, χρησιμοποιήστε αυτήν την επιλογή.' +
            ' Αυτό θα δημιουργήσει μια νέα εργασία στην οποία μπορείτε να εισέλθετε και να αποχωρήσετε, και θα συμπληρώσουμε τις άλλες λεπτομέρειες αργότερα.' +
            ' Κατά την είσοδο, σημειώστε σε ποιον πελάτη εργάζεστε και οτιδήποτε άλλο πρέπει να γνωρίζουμε.</h5>',
        ACCEPT_LABEL: "Δημιουργία εργασίας",
        REJECT_LABEL: "Ακύρωση"
    },
    ASSIGN_TO_NOT_MATCH_CANDIDATE: {
        MESSAGE: 'Υπάρχει μια σχέση "Δεν ταιριάζει" μεταξύ πελάτη και υποψηφίου. Είστε βέβαιοι ότι θέλετε να αναθέσετε την κράτηση σε αυτόν τον υποψήφιο;',
        ACCEPT_LABEL: 'Ναι',
        REJECT_LABEL: "Όχι"
    },
    ASSIGN_TO_UNAVAILABLE_CANDIDATE: {
        MESSAGE: "Ο υποψήφιος δεν είναι διαθέσιμος. Είστε βέβαιοι ότι θέλετε να αναθέσετε την κράτηση σε αυτόν τον υποψήφιο;",
        ACCEPT_LABEL: 'Ναι',
        REJECT_LABEL: "Όχι"
    },
    ASSIGN_TO_ALREADY_BOOKED_CANDIDATE: {
        MESSAGE: "Ο υποψήφιος έχει ήδη κρατηθεί αυτήν τη στιγμή. Είστε βέβαιοι ότι θέλετε να αναθέσετε την κράτηση σε αυτόν τον υποψήφιο;",
        ACCEPT_LABEL: 'Ναι',
        REJECT_LABEL: "Όχι"
    },
    ASSIGN_TO_TIME_OFF_CANDIDATE: {
        MESSAGE: "Ο υποψήφιος έχει άδεια αυτήν τη στιγμή. Είστε βέβαιοι ότι θέλετε να αναθέσετε την κράτηση σε αυτόν τον υποψήφιο;",
        ACCEPT_LABEL: 'Ναι',
        REJECT_LABEL: "Όχι"
    },
    RELEASE_SCHEDULE_CONFIRM_DIALOG: {
        MESSAGE: "Είστε έτοιμοι να δημοσιεύσετε το πρόγραμμα;",
        ACCEPT_LABEL: 'Πρόγραμμα κυκλοφορίας',
        REJECT_LABEL: "Ακύρωση"
    },
    DELETE_BOOKING_GROUP_CONFIRM_DIALOG: {
        MESSAGE: "Είστε βέβαιοι ότι θέλετε να διαγράψετε την ομάδα κρατήσεων;",
    },
    ACCEPT_BOOKING_IN_GROUP_CONFIRM_DIALOG: {
        INNER_HTML: `<h3>Η κράτηση ανήκει σε μια ομάδα. Είστε βέβαιοι ότι θέλετε να αποδεχτείτε όλες τις κρατήσεις σε αυτήν την ομάδα;</h3>
        <ul>{0}</ul>`,
        ACCEPT_LABEL: "Αποδοχή όλων",
        REJECT_LABEL: "Ακύρωση"
    },
    UPDATE_JOB_POSTER_CONFRM_DIALOG: {
        MESSAGE: "Θέλετε να ενημερώσετε ανάλογα τα πεδία διεύθυνσης με νέα αφίσα εργασίας;",
        ACCEPT_LABEL: 'Ναι',
        REJECT_LABEL: "Όχι"
    },
    CLIENT_CONFIRM_CLOCK_IN_OUT_MESSAGE: {
        INNER_HTML: "<h3>Χρόνος εισόδου και χρονομέτρησης του υποψηφίου</h3>" +
            "<ul>{0}</ul>",
        ACCEPT_LABEL: 'Έγκριση',
        REJECT_LABEL: "Ακύρωση"
    },
    CLIENT_APPROVE_CLOCK_IN_OUT_MESSAGE: {
        INNER_HTML: "<h3>Είστε βέβαιοι ότι θέλετε να εγκρίνετε την ώρα εισόδου και χρόνου του υποψηφίου</h3>" +
            "<ul>{0}</ul>",
        ACCEPT_LABEL: 'Έγκριση',
        REJECT_LABEL: "Ακύρωση"
    },
    CLIENT_DISSAPPROVE_CLOCK_IN_OUT_MESSAGE: {
        INNER_HTML: "<h3>Είστε βέβαιοι ότι θέλετε να απορρίψετε την ώρα εισόδου και χρόνου του υποψηφίου</h3>" +
            "<ul>{0}</ul>",
        ACCEPT_LABEL: "Απόρριψη",
        REJECT_LABEL: "Ακύρωση"
    },
    SELECT_CREDIT_PACKAGE_CONFIRM_DIALOG: {
        MESSAGE: "Θα χρεωθείτε {0}{1} για {2} πιστώσεις. Είστε βέβαιοι ότι θέλετε να συνεχίσετε",
        ACCEPT_LABEL: 'Ναι',
        REJECT_LABEL: "Όχι"
    },
    SELECT_SUBSCRIPTION_CREDIT_PACKAGE_CONFIRM_DIALOG: {
        MESSAGE: "Θα εγγραφείτε για {0} μηνιαίες πιστώσεις. Είστε βέβαιοι ότι θέλετε να συνεχίσετε",
        ACCEPT_LABEL: 'Ναι',
        REJECT_LABEL: "Όχι"
    },
    CHANGE_SUBSCRIPTION_CREDIT_PACKAGE_CONFIRM_DIALOG: {
        MESSAGE: "Θα εγγραφείτε για {0} μηνιαίες πιστώσεις. Είστε βέβαιοι ότι θέλετε να ενημερώσετε το τρέχον πακέτο σας",
        ACCEPT_LABEL: 'Ναι',
        REJECT_LABEL: "Όχι"
    },
    SELECT_STRIPE_SUBSCRIPTION_CONFIRM_DIALOG: {
        MESSAGE: "Θα εγγραφείτε στο {0}. Θέλετε να συνεχίσετε;",
        ACCEPT_LABEL: 'Ναι',
        REJECT_LABEL: "Όχι"
    },
    UNASSIGN_CANDIDATE_CONFIRM_DIALOG: {
        MESSAGE: "Είστε βέβαιοι ότι θέλετε να καταργήσετε την ανάθεση αυτού του υποψηφίου;",
        ACCEPT_LABEL: "Ναι",
        REJECT_LABEL: "Όχι"
    },
    UPDATE_RATE_BASED_ON_BOOKING_SERVICE_CONFIRM_DIALOG: {
        MESSAGE: "Θέλετε να ενημερώσετε το ποσοστό πελάτη και το ποσοστό υποψηφίων ανάλογα;",
        ACCEPT_LABEL: "Ναι",
        REJECT_LABEL: "Όχι"
    },
    DELETE_BREAK_CONFIRM_DIALOG: {
        MESSAGE: "Είστε βέβαιοι ότι θέλετε να διαγράψετε αυτό το διάλειμμα;",
        ACCEPT_LABEL: "Ναι",
        REJECT_LABEL: "Όχι"
    },
    BULK_CHARGE_CLIENT_CONFIRM_DIALOG: {
        INNER_HTML: `<h3>Είστε βέβαιοι ότι θέλετε να χρεώσετε πελάτες για τις ακόλουθες εργασίες;</h3>
         <ul>{0}</ul>`,
        ACCEPT_LABEL: "Χρέωση",
        REJECT_LABEL: "Ακύρωση"
    },
    BULK_INVOICE_STRIPE_CLIENT_CONFIRM_DIALOG: {
        INNER_HTML: `<h3>Είστε βέβαιοι ότι θέλετε να στείλετε τιμολόγιο σε πελάτες μέσω Stripe για τις ακόλουθες εργασίες;</h3>
         <ul>{0}</ul>`,
        ACCEPT_LABEL: "Αποστολή τιμολογίου",
        REJECT_LABEL: "Ακύρωση"
    },
    BULK_CHARGE_PAYOUT_STRIPE_CONFIRM_DIALOG: {
        INNER_HTML: `<h3>Είστε βέβαιοι ότι θέλετε να χρεώσετε πελάτες και υποψήφιους πληρωμών μέσω Stripe για τις ακόλουθες εργασίες;</h3>
         <ul>{0}</ul>`,
        ACCEPT_LABEL: "Μεταφορά",
        REJECT_LABEL: "Ακύρωση"
    },
    BULK_COPY_SUGGESTED_CHARGE_CONFIRM_DIALOG: {
        INNER_HTML: `<h3>Είστε βέβαιοι ότι θέλετε να αντιγράψετε την προτεινόμενη χρέωση στη συνολική χρέωση πελάτη για τις ακόλουθες εργασίες;</h3>
         <ul>{0}</ul>`,
        ACCEPT_LABEL: "Ναι",
        REJECT_LABEL: "Όχι"
    },
    SHARE_JOB_MARKET_PLACE_CONFIRM_DIALOG: {
        INNER_HTML: `<h3>Είστε βέβαιοι ότι θέλετε να μοιραστείτε αυτήν την εργασία στην αγορά της εταιρείας με την ακόλουθη χρέωση;</h3>
         <ul>{0}</ul>`,
        ACCEPT_LABEL: "Ναι",
        REJECT_LABEL: "Όχι"
    },
    CLOSE_VIEW_TAB_CONFIRM_DIALOG: {
        MESSAGE: 'Είστε βέβαιοι ότι θέλετε να κλείσετε την προβολή {0}',
        ACCEPT_LABEL: "Ναι",
        REJECT_LABEL: "Όχι"
    },
    DELETE_TODO_CONFIRM_DIALOG: {
        MESSAGE: 'Είστε βέβαιοι ότι θέλετε να διαγράψετε αυτό το To Do;',
        ACCEPT_LABEL: "Ναι",
        REJECT_LABEL: "Όχι"
    },
    DELETE_BENEFIT_CONFIRM_DIALOG: {
        MESSAGE: 'Είστε βέβαιοι ότι θέλετε να διαγράψετε το πλεονέκτημα {0};',
        ACCEPT_LABEL: "Ναι",
        REJECT_LABEL: "Όχι"
    },
    TRANSER_MONEY_CONFIRM_DIALOG: {
        MESSAGE: 'Είστε βέβαιοι ότι θέλετε να στείλετε το {0}{1} στο {2}; ',
        ACCEPT_LABEL: 'Ναι',
        REJECT_LABEL: "Όχι"
    },
    MARK_JOB_COMPLETED_CONFIRM_DIALOG: {
        MESSAGE: 'Είστε βέβαιοι ότι θέλετε να επισημάνετε αυτήν την εργασία ως ολοκληρωμένη;',
        ACCEPT_LABEL: "Ναι",
        REJECT_LABEL: "Όχι"
    },
    DELETE_PACKAGE_CONFIRM_DIALOG: {
        MESSAGE: 'Είστε βέβαιοι ότι θέλετε να διαγράψετε αυτό το πακέτο;',
        ACCEPT_LABEL: "Διαγραφή",
        REJECT_LABEL: "Ακύρωση"
    },
    REPORT_PROBLEM_CONFIRM_DIALOG: {
        MESSAGE: 'Είστε βέβαιοι ότι θέλετε να αναφέρετε το πρόβλημα;',
        ACCEPT_LABEL: "Αναφορά",
        REJECT_LABEL: "Ακύρωση"
    },
    COPY_FIELD_CONFIRM_DIALOG: {
        MESSAGE: 'Είστε βέβαιοι ότι θέλετε να αντιγράψετε δεδομένα από το {0} στο {1};',
        INNER_HTML: `<h3>Είστε βέβαιοι ότι θέλετε να αντιγράψετε δεδομένα;</h3>
         <h4>Από το πεδίο: {0}</h4>
         <h4>Προς πεδίο: {1}</h4>
         <h5>Όλα τα υπάρχοντα δεδομένα του {1} θα αντικατασταθούν</h5>`,
        ACCEPT_LABEL: "Αντιγραφή",
        REJECT_LABEL: "Ακύρωση"
    },
    CANCEL_SCHEDULE_CONFIRM_DIALOG: {
        MESSAGE: 'Είστε βέβαιοι ότι θέλετε να ακυρώσετε το email;',
        ACCEPT_LABEL: "Ναι",
        REJECT_LABEL: "Όχι"
    },
    DELETE_REVIEW_CONFIRM_DIALOG: {
        MESSAGE: 'Είστε βέβαιοι ότι θέλετε να διαγράψετε αυτήν την κριτική;',
        ACCEPT_LABEL: "Διαγραφή",
        REJECT_LABEL: "Ακύρωση"
    },
    DELETE_BLOCK_TEXT_CONFIRM_DIALOG: {
        MESSAGE: 'Είστε βέβαιοι ότι θέλετε να διαγράψετε αυτό το μπλοκ κειμένου;',
        ACCEPT_LABEL: "Διαγραφή",
        REJECT_LABEL: "Ακύρωση"
    },
    DELETE_STRIPE_ACCOUNT_CONFIRM_DIALOG: {
        MESSAGE: 'Είστε βέβαιοι ότι θέλετε να διαγράψετε το stripe λογαριασμό αυτού του χρήστη;',
        ACCEPT_LABEL: "Διαγραφή",
        REJECT_LABEL: "Ακύρωση"
    },
    DEDUPLICATE_CHILDREN_CONFIRM_DIALOG: {
        MESSAGE: "Είστε βέβαιοι ότι θέλετε να αφαιρέσετε τα διπλότυπα παιδιά;",
        ACCEPT_LABEL: "Ναι",
        REJECT_LABEL: "Όχι"
    },
    HIDE_FIELD_FROM_CLIENT_CONFIRM_DIALOG: {
        MESSAGE: 'Είστε βέβαιοι ότι θέλετε να αποκρύψετε αυτό το πεδίο από τον πελάτη;',
        ACCEPT_LABEL: "Ναι",
        REJECT_LABEL: "Όχι"
    },
    SHOW_FIELD_TO_CLIENT_CONFIRM_DIALOG: {
        MESSAGE: 'Είστε βέβαιοι ότι θέλετε να εμφανίσετε αυτό το πεδίο στον πελάτη;',
        ACCEPT_LABEL: "Ναι",
        REJECT_LABEL: "Όχι"
    },
    BOOKING_IN_PAST_DATE_CONFIRM_DIALOG: {
        MESSAGE: 'Η κράτηση είναι σε προηγούμενη ημερομηνία. Θέλετε να συνεχίσετε?',
        ACCEPT_LABEL: "Ναι",
        REJECT_LABEL: "Όχι"
    },
    RESTORE_RESOURCE_CONFIRM_DIALOG: {
        MESSAGE: "Είστε βέβαιοι ότι θέλετε να επαναφέρετε το {0};",
        ACCEPT_LABEL: "Ναι",
        REJECT_LABEL: "Όχι"
    },
    PERMANENT_DELETE_RESOURCE_CONFIRM_DIALOG: {
        MESSAGE: 'Είστε βέβαιοι ότι θέλετε να διαγράψετε οριστικά το {0};',
        ACCEPT_LABEL: "Διαγραφή",
        REJECT_LABEL: "Ακύρωση"
    },
    BULK_DELETE_RESOURCE_CONFIRM_DIALOG: {
        MESSAGE: 'Είστε βέβαιοι ότι θέλετε να διαγράψετε το {0} επιλεγμένο {1};',
        ACCEPT_LABEL: "Διαγραφή",
        REJECT_LABEL: "Ακύρωση"
    },
    BULK_SHIFT_JOB_UPDATE_CONFIRM_DIALOG: {
        MESSAGE: "Είστε βέβαιοι ότι θέλετε να ενημερώσετε {0} εργασίες",
        ACCEPT_LABEL: "Ενημέρωση",
        REJECT_LABEL: "Ακύρωση"
    },
    INVALID_INPUT_WARNING_CONFIRM_DIALOG: {
        INNER_HTML: `
         <h2>Προειδοποίηση, δεν έχετε συμπληρώσει ορισμένα υποχρεωτικά πεδία</h2>
         <h4 class="error-message main-message">
         Αυτά είναι τα πεδία που λείπουν:
         </h4>
         <ul>{0}</ul>
         <h5 class="mt-2">Κάντε κλικ στο Continue για να αγνοήσετε την προειδοποίηση</h5>
         `,
        ACCEPT_LABEL: "Συνέχεια",
        REJECT_LABEL: "Ακύρωση"
    },
    SEND_REPEAT_BLAST_TEMPLATE_CONFIRM_DIALOG: {
        INNER_HTML: `
         <h2>Είστε βέβαιοι ότι θέλετε να στείλετε επαναλαμβανόμενα {0} στο {1}</h2>
         <h5>Πρότυπο: {2}</h5>
         <h5>Επανάληψη κάθε {3} ημέρες {4}</h5>`,
        ACCEPT_LABEL: "Αποστολή",
        REJECT_LABEL: "Ακύρωση"
    },
    DUPLICATE_FIELD_CONFIRM_DIALOG: {
        MESSAGE: 'Είστε βέβαιοι ότι θέλετε να αντιγράψετε το πεδίο;',
        ACCEPT_LABEL: "Ναι",
        REJECT_LABEL: "Όχι"
    },
    DELETE_FIELD_CONFIRM_DIALOG: {
        MESSAGE: 'Είστε βέβαιοι ότι θέλετε να διαγράψετε αυτό το πεδίο;',
        ACCEPT_LABEL: "Διαγραφή",
        REJECT_LABEL: "Ακύρωση"
    },
    DELETE_PROFILE_FIELD_CONFIRM_DIALOG: {
        MESSAGE: 'Είστε βέβαιοι ότι θέλετε να διαγράψετε αυτό το πεδίο; Αυτό θα το διαγράψει από το προφίλ συνολικά (όχι μόνο για αυτό το άτομο!)',
        ACCEPT_LABEL: "Διαγραφή",
        REJECT_LABEL: "Ακύρωση"
    },
    MAKE_FIELD_VISIBLE_CONFIRM_DIALOG: {
        MESSAGE: "Είστε βέβαιοι ότι θέλετε να ορίσετε αυτό το πεδίο ώστε να είναι ορατό στον πελάτη",
        ACCEPT_LABEL: "Ναι",
        REJECT_LABEL: "Όχι"
    },
    MAKE_FIELD_HIDDEN_CONFIRM_DIALOG: {
        MESSAGE: "Είστε βέβαιοι ότι θέλετε να ορίσετε αυτό το πεδίο ώστε να είναι κρυφό από τον πελάτη",
        ACCEPT_LABEL: "Ναι",
        REJECT_LABEL: "Όχι"
    },
    HIDE_BENEFIT_CONFIRM_DIALOG: {
        MESSAGE: "Είστε βέβαιοι ότι θέλετε να αποκρύψετε αυτό το όφελος για την εταιρεία σας",
        ACCEPT_LABEL: "Ναι",
        REJECT_LABEL: "Όχι"
    }
}



// WEBPACK FOOTER //
// ./src/constants/multi-languages/confirm-dialog/el.js